/*
 * Project: BookingEngine
 * Module: reducers/MyBooking.js
 * vim:ft=javascript.jsx:
 */

const mybookingState = {
  booking: null,
};

// eslint-disable-next-line default-param-last
export const mybooking = (state = mybookingState, action) => {
  switch (action.type) {
    case 'MYBOOKING_GET_BOOKING_DETAIL_SUCCESS':
      return { ...state, booking: action.payload.booking };
    case 'MYBOOKING_GET_BOOKING_DETAIL_PENDING':
      return { ...state, booking: null };
    default:
      return state;
  }
};
